module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1), _vm._v(" "), (_vm.development) ? _c('div', [(!_vm.showbtns) ? _c('button', {
    staticStyle: {
      "position": "absolute",
      "bottom": "0px",
      "left": "0px"
    },
    on: {
      "click": function($event) {
        _vm.showbtns = true
      }
    }
  }, [_vm._v("Show devtools")]) : _vm._e(), _vm._v(" "), (_vm.showbtns) ? _c('div', [_c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "well"
  }, [(_vm.showbtns) ? _c('button', {
    staticClass: "pull-right",
    on: {
      "click": function($event) {
        _vm.showbtns = false
      }
    }
  }, [_vm._v("Hide")]) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v("Development tools")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h5', [_vm._v("Task state:")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentTaskStatus('clean')
      }
    }
  }, [_vm._v("Clean")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentTaskStatus('started')
      }
    }
  }, [_vm._v("Started")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentTaskStatus('completed')
      }
    }
  }, [_vm._v("Complete")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentTaskStatus('aborted')
      }
    }
  }, [_vm._v("Aborted")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h5', [_vm._v("Context state")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentContext('done')
      }
    }
  }, [_vm._v("Done")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentContext('consent')
      }
    }
  }, [_vm._v("Consent")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentContext('task')
      }
    }
  }, [_vm._v("Task")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentContext('feedback')
      }
    }
  }, [_vm._v("Feedback")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h5', [_vm._v("Task part")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentTaskComponent('instruction')
      }
    }
  }, [_vm._v("Instruction")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentTaskComponent('training')
      }
    }
  }, [_vm._v("Training")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentTaskComponent('trainingcompleted')
      }
    }
  }, [_vm._v("\n                        Training Completed\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentTaskComponent('test')
      }
    }
  }, [_vm._v("Test")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentTaskComponent('recall')
      }
    }
  }, [_vm._v("Recall")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentTaskComponent('delayed')
      }
    }
  }, [_vm._v("Delayed")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentTaskComponent('recognition')
      }
    }
  }, [_vm._v("Recognition")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentTaskComponent('testcompleted')
      }
    }
  }, [_vm._v("Test Completed")])])])]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-427a9fc7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 518
// module chunks = 62